// Tracks the feature flags currently read by mounted components. The data can
// be consumed by diagnostics without coupling tracking to a visual overlay.

const usage = new Map();
const listeners = new Set();

let snapshot = [];

const computeSnapshot = () =>
   Object.freeze(
      Array.from(usage.entries()).map(([key, { value }]) => Object.freeze({ key, value }))
   );

const notify = () => {
   snapshot = computeSnapshot();
   listeners.forEach((listener) => listener());
};

export const registerFlagUsage = (flagKey, value) => {
   const existing = usage.get(flagKey);

   if (existing) {
      existing.count += 1;
      existing.value = value;
   } else {
      usage.set(flagKey, { count: 1, value });
   }

   notify();
};

export const unregisterFlagUsage = (flagKey) => {
   const existing = usage.get(flagKey);
   if (!existing) return;

   if (existing.count <= 1) {
      usage.delete(flagKey);
   } else {
      existing.count -= 1;
   }

   notify();
};

export const resetFlagUsage = () => {
   usage.clear();
   notify();
};

export const subscribeToFlagUsage = (listener) => {
   listeners.add(listener);
   return () => listeners.delete(listener);
};

export const getFlagUsageSnapshot = () => snapshot;
